import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import './Blog.css';

export default function Blog() {
  const [posts, setPosts]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/blog').then(r => setPosts(r.data.posts)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="page-hero">
        <div className="container">
          <h1>Research Blog</h1>
          <p>Latest peptide research insights, studies, and compound guides</p>
        </div>
      </div>
      <div className="container section">
        {loading ? <div className="loading-center"><div className="spinner" /></div> : (
          <div className="grid-3">
            {posts.map(post => (
              <article key={post.id} className="blog-card card">
                <div className="blog-card__img">
                  <span className="blog-card__category badge badge-green">{post.category}</span>
                </div>
                <div className="blog-card__body">
                  <p className="blog-card__meta">🕒 {post.readTime} · {new Date(post.publishedAt).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
                  <h2>{post.title}</h2>
                  <p className="blog-card__excerpt">{post.excerpt}</p>
                  <Link to={`/blog/${post.slug}`} className="btn btn-secondary btn-sm">Read More →</Link>
                </div>
              </article>
            ))}
            {posts.length === 0 && <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '4rem', color: 'var(--gray-400)' }}>No posts yet. Check back soon!</div>}
          </div>
        )}
      </div>
    </div>
  );
}
